<template>
	<section class="brand_highlight_slider" :style="cssVars">
		<div class="container">
			<div
				class="brand_highlight_slider__inner"
				:class="{ flip_horizontally: flip_horizontally }"
			>
				<div
					class="brand_highlight_slider__inner__text"
					:class="{ flip_horizontally: flip_horizontally }"
				>
					<div class="cta_container brands">
						<primary-button
							v-if="parsedBrandsCta"
							:link="parsedBrandsCta.url ? parsedBrandsCta : false"
							:label="parsedBrandsCta.title ? parsedBrandsCta.title : null"
							:theme="'normal'"
						></primary-button>
					</div>

					<div class="inner">
						<div class="brand_highlight_container">
							<ul>
								<li v-for="(brand, index) in parsedBrands" :key="index">
									<a :href="brand.url"><span v-html="brand.title"></span></a>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div
					class="brand_highlight_slider__inner__slider"
					:class="{ flip_horizontally: flip_horizontally }"
				>
					<div class="cta_container slides">
						<primary-button
							v-if="parsedSlidesCta"
							:link="parsedSlidesCta.url ? parsedSlidesCta : false"
							:label="parsedSlidesCta.title ? parsedSlidesCta.title : null"
							:theme="'normal'"
						></primary-button>

						<div class="slider_navigation">
							<div :class="'swiper-button-prev' + ' swiper-prev-' + section_id">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M15 18L9 12L15 6"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
							<div
								:class="'swiper-button-next ' + ' swiper-next-' + section_id"
							>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9 18L15 12L9 6"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
						</div>
					</div>

					<div class="swiper-container" :class="'swiper-' + section_id">
						<div class="swiper-wrapper">
							<div
								class="swiper-slide"
								v-for="(content, index) in parsedSlides"
								:key="index"
							>
								<content-tile :content="content" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import ContentTile from './ContentTile.vue';
import Swiper from 'swiper';

export default {
	data() {
		return {
			swiper: null,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {},
		subtitle: {},
		text: {},
		primary_button: {},
		content: {},
		text_alignment: {},
		flip_horizontally: {},
		background_colour: {},
		brands: {},
		slides: {},
		text_colour: {},
		section_id: {},
		brands_cta: {},
		slides_cta: {},
	},

	computed: {
		parsedBrands() {
			if (this.brands) {
				try {
					return JSON.parse(this.brands);
				} catch (e) {
					return this.brands;
				}
			} else {
				return [];
			}
		},

		parsedSlides() {
			if (this.slides) {
				try {
					const slides = JSON.parse(this.slides);
					return slides.map((slide) => ({
						image: slide.image,
						title: slide.caption,
						link: slide.link || '#',
					}));
				} catch (e) {
					return this.slides;
				}
			} else {
				return [];
			}
		},

		parsedBrandsCta() {
			if (this.brands_cta) {
				try {
					return JSON.parse(this.brands_cta);
				} catch (e) {
					return this.brands_cta;
				}
			} else {
				return null;
			}
		},

		parsedSlidesCta() {
			if (this.slides_cta) {
				try {
					return JSON.parse(this.slides_cta);
				} catch (e) {
					return this.slides_cta;
				}
			} else {
				return null;
			}
		},

		parsedPrimaryButton() {
			if (this.primary_button) {
				try {
					return JSON.parse(this.primary_button);
				} catch (e) {
					return this.primary_button;
				}
			} else {
				return null;
			}
		},

		cssVars() {
			return {
				'--text-alignment': this.text_alignment
					? this.text_alignment
					: 'center',
				'--white': this.background_colour,
				'--text-colour': this.text_colour,
				'--size': '2 / span 10',
			};
		},
	},

	methods: {
		initSwiper() {
			const swiperEl = this.$el.querySelector('.swiper-' + this.section_id);
			if (swiperEl && this.parsedSlides.length > 0) {
				this.swiper = new Swiper(swiperEl, {
					slidesPerView: 1,
					spaceBetween: 10,
					autoHeight: true,
					loop: false,
					navigation: {
						nextEl: '.swiper-next-' + this.section_id,
						prevEl: '.swiper-prev-' + this.section_id,
					},
					breakpoints: {
						768: {
							slidesPerView: 1,
							spaceBetween: 10,
						},
						1024: {
							slidesPerView: 1,
							spaceBetween: 10,
						},
					},
				});
			}
		},

		goNext() {
			if (this.swiper && typeof this.swiper.slideNext === 'function') {
				this.swiper.slideNext();
			}
		},

		goPrev() {
			if (this.swiper && typeof this.swiper.slidePrev === 'function') {
				this.swiper.slidePrev();
			}
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			if (this.swiper && typeof this.swiper.update === 'function') {
				this.swiper.update();
			}
		},
	},

	components: {
		PrimaryButton,
		ContentTile,
	},

	mounted() {
		this.$nextTick(() => {
			this.initSwiper();
		});
	},

	updated() {
		this.$nextTick(() => {
			if (!this.swiper && this.parsedSlides.length > 0) {
				this.initSwiper();
			}
		});
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		if (this.swiper) {
			this.swiper.destroy();
		}
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.brand_highlight_slider {
	overflow: hidden !important;
	background: var(--fpe-light-grey);

	@media (max-width: $mobile-xl) {
		max-height: unset;
		overflow-x: hidden;
		padding: 0;
	}

	.container {
		position: relative;
		padding-top: 0;
		padding-bottom: 0;

		@media (max-width: $mobile-xl) {
			margin: 0;
			max-width: 100%;
		}
	}

	&__inner {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 10px;
		row-gap: 42px;
		grid-column: span 12;
		position: relative;
		overflow: hidden;
		padding: 32px 0 24px;
		border-top: 1px solid var(--white);
		margin-top: 48px;

		@media (max-width: $mobile-xl) {
			border-radius: 0;
			row-gap: 32px;
		}

		.brand_highlight_container {
			ul {
				list-style: none;
				padding: 0;
				/* display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: 20px; */
				column-count: 2;
				column-fill: inherit;

				@media (max-width: $mobile-xl) {
					grid-template-columns: 1fr;
					column-width: 50px;
					column-count: 1;
				}

				li {
					border-bottom: 1px solid var(--fpe-blue);
					padding-bottom: 5px;
					margin-bottom: 20px;

					&:hover {
						border-bottom: 1px solid var(--fpe-light-brown);
						transition: 0.2s ease all;
					}

					a {
						padding: 0;
						border-right: 0;
						border: none;
						position: relative;
						display: flex;
						align-items: center;
						gap: 12px;
						text-transform: uppercase;
						color: var(--fpe-blue);
						text-decoration: none;
						position: relative;
						overflow: hidden;
						font: normal normal 300 14px/18px var(--primary-font-family);

						span {
							transition: 0.2s ease all;
							font: normal normal 300 14px/18px var(--primary-font-family);
							position: relative;
							left: 0;
						}

						@media (max-width: $mobile-xl) {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						&:hover {
							span {
								position: relative;
								left: -21px;
								transition: 0.2s ease all;
								color: var(--fpe-light-brown);
							}

							&::before {
								opacity: 0;
								transition: 0.2s ease all;
								transform: translateX(-100%);
								visibility: hidden;
							}

							&::after {
								opacity: 1;
								transition: 0.2s ease all;
								transform: translateX(-21px);
								visibility: visible;
							}
						}

						&::before {
							content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjNTM2MjhCIi8+Cjwvc3ZnPgo=');
							/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
							opacity: 1;
							transition: 0.2s ease all;
							transform: translateX(0);
							visibility: visible;
						}

						&::after {
							content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjOWQ4ODc5Ii8+Cjwvc3ZnPgo=');
							/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
							opacity: 0;
							transition: 0.2s ease all;
							transform: translateX(0);
							visibility: hidden;
						}
					}
				}
			}
		}

		.cta_container {
			margin-top: 0;
			display: flex;
			justify-content: space-between;
			flex-direction: row;
			flex-wrap: wrap;
			gap: 24px;
			min-width: 100%;
			grid-column: 7 / span 6;
			position: relative;
			margin-bottom: 36px;

			&.brands {
				grid-column: 1 / span 6;

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 4;
					margin-bottom: 0;
					margin-top: 16px;
				}
			}
			&.slides {
				grid-column: 7 / span 6;

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 4;
					margin-bottom: 0;
					margin-top: 24px;
				}
			}

			@media (max-width: $mobile-xl) {
				margin-top: 0;
				text-align: left;
				display: flex;
				flex-wrap: wrap;
				gap: var(--spacer-mobile);
				grid-column: span 4;
				order: 1;
			}

			.slider_navigation {
				position: relative;
				top: 0;
				right: 0;
				z-index: 10;
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 10px;
				width: 180px;
				height: 48px;
				justify-content: space-between;

				.swiper-button-prev,
				.swiper-button-next {
					width: 40px;
					height: 46px;
					background: var(--fpe-light-grey);
					border-radius: 30px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					transition: 0.2s ease all;
					color: var(--fpe-blue);
					border: 1px solid var(--white);
					position: relative;
					top: 0;
					margin-top: 0;
					left: 0;
					right: 0;
					min-width: 80px;
					/* box-shadow: 0px -0px 0 var(--fpe-blue); */

					&:hover {
						background: var(--white);
						transition: 0.2s ease all;
						color: var(--fpe-blue);
						/* box-shadow: 1px -1px 0 var(--fpe-blue); */

						svg {
							path {
								stroke: var(--fpe-blue);
							}
						}
					}

					svg {
						width: 16px;
						height: 16px;
					}
				}
			}
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr 1fr;
			grid-column: 1 / span 4;
		}

		&.flip_horizontally {
			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				border-radius: 0 0 0 0;
			}
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: 1fr;
			column-gap: 0;
			grid-column: span 4;
		}

		&__text {
			grid-column: 1 / span 6;
			background: transparent 0% 0% no-repeat padding-box;
			opacity: 1;
			display: flex;
			flex-direction: column;
			gap: var(--gutter-tablet-desktop);
			font: normal normal normal 17px/24px var(--primary-font-family);
			gap: 10px;
			/* background: var(--fpe-mid-grey); */
			border-radius: 0;
			z-index: 0;

			@media (max-width: $mobile-xl) {
				gap: 16px;
				order: 0;
			}

			&.flip_horizontally {
				grid-column: 7 / span 6;
				order: 1;

				@media (max-width: $mobile-xl) {
					order: 0;
					grid-column: span 1;
					margin-right: 0;
					min-height: auto;
				}

				.inner {
					grid-column: 1 / span 12;
					padding: 0 0 0 50px;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						border-right: unset;
					}
				}
			}

			h6 {
				font-size: 14px;
				font-style: normal;
				font-weight: 700;
				line-height: 18px;
				letter-spacing: 0.4px;
				text-transform: uppercase;
				color: var(--text-colour);
				margin: 0 0 24px;
			}

			.content {
				&::v-deep {
					p {
						color: var(--text-colour);
						margin: 0;
						margin-bottom: 24px;
						z-index: 10;
						font-family: var(--primary-font-family-heading);
						font-size: 24px;
						font-style: normal;
						font-weight: 300;
						line-height: 26px; /* 108.333% */
						letter-spacing: 0.3px;

						@media (max-width: $tablet) {
							font-size: 22px;
							font-style: normal;
							font-weight: 300;
							line-height: 26px; /* 118.182% */
							letter-spacing: 0.3px;
							margin-bottom: 0;
						}
					}
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;

				.the_subtitle {
					text-align: center;
				}
			}

			.body {
				z-index: 10;

				&::v-deep {
					p {
						margin: 0 0 32px;
						font: normal normal 300 16px/24px var(--primary-font-family);
						color: var(--text-colour);

						@media (max-width: $mobile-xl) {
							text-align: left;
						}

						&:last-of-type {
							margin: 0 0 0;
						}
					}
				}
			}

			.inner {
				grid-column: 2 / span 12;
				min-height: 200px;
				padding: 0 50px 0 0;
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 130px;
				pointer-events: all;
				justify-content: flex-start;
				height: 100%;

				@media (max-width: $mobile-xl) {
					max-height: unset;
					grid-column: span 4;
					border-left: unset;
					padding: 0;
					gap: 32px;
					min-height: unset;
				}
			}
		}

		&__slider {
			grid-column: 7 / span 6;
			opacity: 1;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			border-radius: 0;
			/* overflow: hidden; */
			position: relative;
			z-index: 5;
			min-height: 100%;
			/* background: var(--white); */

			&.flip_horizontally {
				order: 0;
				justify-content: center;
				grid-column: 1 / span 6;
				overflow: hidden;
				position: relative;

				@media (max-width: $mobile-xl) {
					order: 1;
					margin-right: 0;
					min-height: auto;
					padding-left: unset;
				}
			}

			@media (max-width: $mobile-xl) {
				height: unset;
				border-left: unset;
				padding-right: unset;
				order: 2;
				grid-column: 1 / span 4;
				margin-right: 0;
				min-height: auto;
			}

			.swiper-wrapper {
				height: 100% !important;

				.swiper-slide {
					height: 100% !important;
				}
			}

			.swiper-container {
				width: 100%;
				/* height: 100%; */
				padding: 0;

				.swiper-slide {
					height: auto;
				}

				.product_card {
					background: var(--white);
					border-radius: 10px;
					overflow: hidden;
					box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
					transition: 0.2s ease all;
					height: 100%;
					display: flex;
					flex-direction: column;

					&:hover {
						transform: translateY(-5px);
						box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
					}

					.product_image {
						width: 100%;
						height: 200px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}

					.product_content {
						padding: 20px;
						flex: 1;
						display: flex;
						flex-direction: column;

						h3 {
							font-size: 18px;
							font-weight: 600;
							margin: 0 0 10px 0;
							color: var(--charcoal);
						}

						.product_excerpt {
							font-size: 14px;
							line-height: 1.5;
							color: var(--medium-grey);
							margin-bottom: 15px;
							flex: 1;
						}

						.product_link {
							color: var(--fpe-blue);
							text-decoration: none;
							font-weight: 600;
							font-size: 14px;
							text-transform: uppercase;
							letter-spacing: 0.5px;
							transition: 0.2s ease all;

							&:hover {
								color: var(--fpe-blue);
							}
						}
					}
				}
			}
		}
	}
}
</style> 


// WEBPACK FOOTER //
// resources/assets/scripts/vue/BrandsHighlight.vue